
(function(){
  function openPrivacyChoices(){
    try{
      if(window.privacyBanner){
        if(typeof window.privacyBanner.showPreferences==='function'){
          window.privacyBanner.showPreferences();
          return true;
        }
        if(typeof window.privacyBanner.show==='function'){
          window.privacyBanner.show();
          return true;
        }
      }
      if(window.Shopify && window.Shopify.customerPrivacy){
        var cp=window.Shopify.customerPrivacy;
        if(typeof cp.showPreferences==='function'){ cp.showPreferences(); return true; }
        if(typeof cp.openPreferences==='function'){ cp.openPreferences(); return true; }
      }
    }catch(e){}
    var request=document.getElementById('privacy-request');
    if(request){
      request.scrollIntoView({behavior:'smooth',block:'start'});
      return true;
    }
    window.location.href='/policies/privacy-policy#privacy-request';
    return true;
  }

  document.addEventListener('click',function(e){
    var btn=e.target.closest('[data-dhc-privacy-choices]');
    if(!btn)return;
    e.preventDefault();
    openPrivacyChoices();
  });

  window.DHCPrivacyChoices={open:openPrivacyChoices};
})();
